export interface Currency {
  code: string;
  name: string;
  symbol: string;
  symbolPosition: 'before' | 'after';
  decimalSeparator: string;
  thousandsSeparator: string;
}

export const CURRENCIES: Currency[] = [
  { code: 'USD', name: 'US Dollar', symbol: '$', symbolPosition: 'before', decimalSeparator: '.', thousandsSeparator: ',' },
  { code: 'EUR', name: 'Euro', symbol: '€', symbolPosition: 'after', decimalSeparator: ',', thousandsSeparator: '.' },
  { code: 'GBP', name: 'British Pound', symbol: '£', symbolPosition: 'before', decimalSeparator: '.', thousandsSeparator: ',' },
  { code: 'JPY', name: 'Japanese Yen', symbol: '¥', symbolPosition: 'before', decimalSeparator: '.', thousandsSeparator: ',' },
  { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$', symbolPosition: 'before', decimalSeparator: '.', thousandsSeparator: ',' },
  { code: 'AUD', name: 'Australian Dollar', symbol: 'A$', symbolPosition: 'before', decimalSeparator: '.', thousandsSeparator: ',' },
  { code: 'INR', name: 'Indian Rupee', symbol: '₹', symbolPosition: 'before', decimalSeparator: '.', thousandsSeparator: ',' },
  { code: 'CNY', name: 'Chinese Yuan', symbol: '¥', symbolPosition: 'before', decimalSeparator: '.', thousandsSeparator: ',' },
];

export const getCurrency = (code: string): Currency => {
  return CURRENCIES.find(c => c.code === code) || CURRENCIES[0];
};

export const getCurrencySymbol = (code: string): string => {
  return getCurrency(code).symbol;
};

export const formatCurrency = (amount: number, currencyCode: string = 'USD'): string => {
  const currency = getCurrency(currencyCode);
  
  // Format the number with proper separators
  const parts = Math.abs(amount).toFixed(0).split('.');
  const integerPart = parts[0];
  
  // Add thousands separator
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, currency.thousandsSeparator);
  
  // Combine with symbol
  const sign = amount < 0 ? '-' : '';
  if (currency.symbolPosition === 'before') {
    return `${sign}${currency.symbol}${formattedInteger}`;
  } else {
    return `${sign}${formattedInteger}${currency.symbol}`;
  }
};

export const getCurrencyList = (): Currency[] => {
  return CURRENCIES;
};
